module.exports = __webpack_public_path__ + "img/logo.5bd7a153.svg";